/* eslint-disable react/prop-types */
import { Avatar, Box, Checkbox, Typography, Tooltip } from '@mui/material';
import { capitalize } from '../../hepler/functions';
import stylesLogo from './Account.styles';
import sizeFontCustom from '../Discovery/fontSize.styles';
import { useTranslation } from '../../hooks/useTranslation';
import { getFipLogoAlt } from '../../utils/fipLogo.utils';
import { isAccountMandatory } from '../../utils/targetedAccounts.utils';

function AccountCheckBox(props) {
	const { t } = useTranslation();
	const {
		acc,
		handleCheckboxChange,
		selectedAccounts,
		consent,
		superState,
		accountRestrictions,
		...rest
	} = props;
	const isActiveFlag = rest?.selectedConsentsState?.includes(
		rest?.consentHandle,
	);

	const isMandatory = isAccountMandatory(acc);

	const accountRestriction = accountRestrictions?.[acc?.accRefNumber];
	const isRestricted = accountRestriction?.isRestricted || false;
	const restrictionReason = accountRestriction?.reason || '';

	const isChecked = consent
		? superState?.consentSelectedAccounts[consent.ConsentHandle]?.includes(acc)
		: selectedAccounts?.includes(acc) || false;

	const isDisabled = !isActiveFlag || isRestricted || isMandatory;

	const fipName = t(`fips.${global.objectFormatFip[acc?.fipId]?.fipId}`);
	const accountLabel = `${fipName} ${acc?.maskedAccNumber?.replaceAll('X', '\u2022')}`;

	const handleRowClick = (event) => {
		if (event.target.closest('.MuiCheckbox-root') || isDisabled) {
			return;
		}
		handleCheckboxChange(
			{
				...event,
				target: {
					checked: !isChecked,
					name: acc?.accRefNumber,
				},
			},
			acc,
			isMandatory,
		);
	};

	const handleCheckboxInputChange = (event) => {
		if (isDisabled) {
			return;
		}
		handleCheckboxChange(event, acc, isMandatory);
	};

	return (
		<Tooltip
			title={isRestricted ? restrictionReason : ''}
			arrow
			placement="top"
			disableHoverListener={!isRestricted}
		>
			<Box
				onClick={handleRowClick}
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					cursor: isRestricted ? 'not-allowed' : 'pointer',
					alignItems: 'flex-start',
					p: '1rem',
					opacity: isRestricted ? 0.6 : 1,
				}}
			>
				<Box sx={stylesLogo.container}>
					<Avatar
						alt={getFipLogoAlt(acc?.fipId, fipName)}
						src={global.objectFormatFip[acc?.fipId]?.productIconUri}
						sx={stylesLogo.avatarStyle}
					/>
					<Box textAlign="left">
						<Typography sx={sizeFontCustom.subHeading} noWrap={false}>
							{fipName}
						</Typography>

						<Typography sx={stylesLogo.account}>
							{capitalize(acc?.accType) +
								' ' +
								acc?.maskedAccNumber?.replaceAll('X', '\u2022')}
						</Typography>
					</Box>
				</Box>
				<Checkbox
					name={acc?.accRefNumber}
					disabled={isDisabled}
					size="small"
					sx={{ height: '18px', width: '18px', p: 0 }}
					checked={isRestricted ? false : isChecked}
					onChange={handleCheckboxInputChange}
					onClick={(event) => event.stopPropagation()}
					inputProps={{ 'aria-label': accountLabel }}
				/>
			</Box>
		</Tooltip>
	);
}

export default AccountCheckBox;
